import React from 'react';
import {FazendaObject} from "../../models/Fazenda";
import {IonIcon, IonRouterLink} from "@ionic/react";
import {star} from "ionicons/icons";

export const fazendaCardTitle = (fazenda: FazendaObject) => (
  <div className="flex items-center gap-4">
    <div className="flex-grow">
      {fazenda.designacao &&
        <span>{fazenda.designacao} </span>
      }
      {fazenda.nome}
    </div>
    {fazenda.matriz &&
      <div className="flex flex-col justify-center">
        <IonIcon icon={star} className="ml-4 text-4xl float-right text-yellow-400"
                 style={{minWidth: '42px', width: '42px'}}/>
      </div>
    }
  </div>
);

export const fazendaCardSubtitle = (fazenda: FazendaObject) => (
  <>
    {fazenda.tipo.join(', ')}
  </>
);

export const fazendaCardContent = (fazenda: FazendaObject) => (
  <>
    {fazenda.veterinario.length > 0 &&
      <div>{fazenda.veterinario.map(i => i.label).join(', ')}</div>
    }

    <div>{fazenda.cidade} ({fazenda.estado})</div>
    {fazenda.email &&
      <div>
        <IonRouterLink href={`mailto:${fazenda.email}`}>
          {fazenda.email}
        </IonRouterLink>
      </div>
    }

    {fazenda.telefone &&
      <div>
        {fazenda.telefone}
      </div>
    }

    <div className="text-xs text-gray-500 mt-2 flex md:gap-8 gap-6 justify-center font-condensed w-full">
      <div>Eventos: {fazenda._numEventos}</div>
      <div>Quantidade de animais: {fazenda.quantidade_animais}</div>
      {fazenda.tipo.indexOf('Leite') !== -1 &&
        <div>Produção litros/dia: {fazenda.producao_litros_dia}</div>
      }
    </div>
  </>
);